export default {
  getListGroupFAQ (state, payload) {
    state.group_faqs = payload.data ? payload.data : payload
    state.last_page = payload.meta ? payload.meta.last_page : 0
    state.total = payload.meta ? payload.meta.total : 0
  }
}



// WEBPACK FOOTER //
// ./src/store/module/group-faq/mutations.js